<template>
  <CustomerListItem v-if="!editMode" :item="editItem.Customer" @click="openCustomer()">
  </CustomerListItem>

  <v-container v-else class="pt-0">
    <CustomerSelect v-model="editItem.CustomerId" :externaledit="isNew || editMode" @FocusState="handleFocus">
    </CustomerSelect>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from '@/components/Inputs/EntityDropdowns/CustomerSelect2.vue';
import CustomerListItem from "@/components/ListItems/CustomerListItem.vue";

export default {
  name: "MachineCustomerEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    CustomerSelect,
    CustomerListItem,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    openCustomer() {
      this.$router.push({ name: 'ViewCustomer', params: { customerId: this.editItem.CustomerId } })
    }
  },

  computed: {
    isNew() {
      return this.editItem?.Id == null;
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>